<template>
  <VueScheduler
      :data="timelineData.data"
      :headers="timelineHeaders"
      :interactive="false"
      :items="timelineRows"
      :options="timelineOptions"
      v-if="false"
  >
    <template #event="{ event, properties }">
      <div
          :class="[
          event.color,
          event.text,
          'p-2',
          'rounded-lg',
          'shadow-md',
          'text-xs',
          'text-left',
          'text-xs',
          'rounded-md',
          'text-nowrap',
          'overflow-auto',
          'opacity-80',
          'truncate',
        ]"
          :style="{ width: properties.width + 'px' }"
      >
        <div class="flex flex-col truncate">
          <div class="font-bold">{{ event.meta?.title }}</div>
          <div class="text-slate-200">{{ event.meta?.description }}</div>
        </div>
      </div>
    </template>
  </VueScheduler>
  <UniversalScheduler :schedule-data="timelineData" :rows="timelineRows" :focused="aufgabe"/>
</template>

<script lang="ts" setup>
import VueScheduler from "@/components/misc/VueScheduler.vue";
import {TimelineOptions, TimelineRow} from "@/types/VueScheduler";
import {Task, convertAuftragToTimelineFormat, Group, Groups} from "@/types/Order";
import {ref} from "vue";
import UniversalScheduler from "@/components/misc/UniversalScheduler.vue";

const auftrag = defineModel()
const aufgabe = defineModel<Task>('aufgabe')

//console.log("aufgabe", aufgabe.value)

/**
 * Timeline data
 * [
 *   {
 *     row: 0,
 *     background: "bg_color_pro-rot",
 *     text: "text-white",
 *     start: "17/02/2024 01:00",
 *     end: "17/02/2024 02:00",
 *     meta: {title: "Event 1", description: "Event 1 description"},
 *   },
 *   {
 *     row: 1,
 *     background: "bg_color_pro-dunkelblau",
 *     text: "text-white",
 *     start: "17/02/2024 01:00",
 *     end: "17/02/2024 02:15",
 *     meta: {title: "Event 2", description: "Event 2 description"},
 *   },
 *   {
 *     row: 2,
 *     background: "bg_color_pro-dunkelgrau",
 *     text: "text-white",
 *     start: "17/02/2024 02:00",
 *     end: "17/02/2024 03:15",
 *     meta: {title: "Event 3", description: "Event 3 description"},
 *   }
 * ]
 */
//console.log("before", auftrag.value);
const timelineData = convertAuftragToTimelineFormat(auftrag.value as any)
//console.log("after", timelineData)


/**
 * Timeline headers
 */
const timelineHeaders = ref([""]);

/**
 * Generate row data
 */
const timelineRows: Group[] = [
  /*  {
      id: 0,
      name: "Produktion",
      color: "pro_rot",
      height: 0,
      marginTop: 0,
    },
    {
      id: 1,
      name: "TDE",
      color: "pro_hellblau",
      height: 0,
      marginTop: 0,
    },
    {
      id: 2,
      name: "TDM",
      color: "pro_hellgrau",
      height: 0,
      marginTop: 0,
    },*/
  Groups.produktion, Groups.tde, Groups.tdm
];

/**
 * Timeline options
 */
const timelineOptions = ref<TimelineOptions>({
  cellWidth: 85,
  row: {
    height: 50,
    marginTop: 0,
  },
  scale: 0.5,
  start: timelineData.min,
  end: timelineData.max,
});
</script>